// © 2026 AttainIP Engineering
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '@/lib/auth';

// The DevOps admin console front door. `isAuthenticated` admits platform_admin
// ONLY (see lib/auth ADMIN_ROLES) — a logged-in customer/org_admin without
// platform_admin is bounced to /login, never entering the operator console.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
